export const SITE = {
  name: "901 Lots",
  domain: "901lots.com",
  email: "jack@901lots.com",
  phone: "(901) 641-2532",
  phoneHref: "tel:+19016412532",
  tagline: "Parking Lot Striping & Sealcoating — Memphis & the Mid-South",
};

export const SERVICES = [
  {
    slug: "parking-lot-striping",
    title: "Parking Lot Striping",
    short: "Crisp, code-compliant lines that make your lot look brand new.",
    description:
      "Fresh stall striping with high-durability traffic paint. We layout, mask, and paint single or double lines, fire lanes, and curb markings — engineered to last through Mid-South seasons.",
    bullets: [
      "New layouts & restriping",
      "Fire lanes and no-parking zones",
      "Curb painting (red, yellow, blue)",
      "Numbered stalls & reserved spots",
    ],
  },
  {
    slug: "sealcoating",
    title: "Sealcoating & Resealing",
    short: "Protect your asphalt investment from UV, water, and oxidation.",
    description:
      "Commercial-grade asphalt sealer applied at the right cure window. Sealcoating extends pavement life by 5–10 years and gives your lot that rich, dark, just-paved look.",
    bullets: [
      "Coal-tar or asphalt emulsion sealer",
      "Crack cleaning & prep included",
      "1–2 coat applications",
      "After-hours work to minimize closure",
    ],
  },
  {
    slug: "ada-compliance",
    title: "ADA Compliance",
    short: "Accessible stalls, signage, and access aisles done right.",
    description:
      "We design, mark, and install ADA-compliant accessible parking — including van-accessible aisles, signage at proper heights, and blue/white pavement symbols. Avoid fines and serve every customer.",
    bullets: [
      "Accessible stalls & aisles",
      "Compliant signage installation",
      "International Symbol of Access",
      "Layouts to current ADA standards",
    ],
  },
  {
    slug: "restriping",
    title: "Restriping & Refresh",
    short: "Faded lines? We bring tired lots back to life — fast.",
    description:
      "Re-paint over existing layouts so customers stop guessing where to park. Same-day mobilization on many lots and minimal disruption to your business hours.",
    bullets: [
      "Same-layout repaint",
      "Quick-dry traffic paint",
      "Weekend & overnight crews",
      "Touch-up programs available",
    ],
  },
  {
    slug: "pavement-markings",
    title: "Pavement Markings",
    short: "Arrows, stop bars, crosswalks, speed bumps — clearly marked.",
    description:
      "Custom stencils and directional markings to keep traffic flowing safely. Loading zones, drive-thru lanes, EV stalls, and custom logos all available.",
    bullets: [
      "Directional arrows & stop bars",
      "Crosswalks & speed bumps",
      "EV charging stalls",
      "Custom stencils & logos",
    ],
  },
  {
    slug: "crack-filling",
    title: "Crack Filling",
    short: "Stop small cracks from becoming expensive potholes.",
    description:
      "Hot-applied rubberized crack filler seals out water and freeze/thaw damage. Best paired with sealcoating for full pavement protection.",
    bullets: [
      "Hot-pour rubberized sealant",
      "Routing for wider cracks",
      "Pre-seal preparation",
      "Extends pavement life",
    ],
  },
];

export const SERVICE_AREAS = [
  { city: "Memphis", state: "TN" },
  { city: "Germantown", state: "TN" },
  { city: "Collierville", state: "TN" },
  { city: "Bartlett", state: "TN" },
  { city: "Cordova", state: "TN" },
  { city: "Lakeland", state: "TN" },
  { city: "Arlington", state: "TN" },
  { city: "Millington", state: "TN" },
  { city: "Olive Branch", state: "MS" },
  { city: "Southaven", state: "MS" },
  { city: "Horn Lake", state: "MS" },
  { city: "Hernando", state: "MS" },
  { city: "Tupelo", state: "MS" },
  { city: "Oxford", state: "MS" },
  { city: "West Memphis", state: "AR" },
  { city: "Marion", state: "AR" },
  { city: "Jonesboro", state: "AR" },
  { city: "Jackson", state: "TN" },
];
